import { Component } from '@angular/core';
import { TenantConfigService } from '../../../../../../../../tenant-config/tenant-config.service';

@Component({
  selector: 'hf-new-chat-template',
  templateUrl: './new-chat-template.component.html',
  styleUrls: ['./new-chat-template.component.scss']
})
export class NewChatTemplateComponent {
  public readonly tenantConfigService: TenantConfigService;

  constructor(tenantConfigService: TenantConfigService) {
    this.tenantConfigService = tenantConfigService;
  }
}
